module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/why-pict-3b80f218055454e3590c048f8e75e7ba.jpg";